export default {
    invites: {},
}